import type { ReactNode } from "react";
import { Link as RouterLink } from "react-router";
import { PrivacyContent } from "@/design/PrivacyContent";
import { SupportContent } from "@/design/SupportContent";
import { PublicPage } from "~/components/SiteChrome";

/**
 * The two compliance pages (R22 T12).
 *
 * The App Store's support URL and Play's account-deletion URL point here, and a
 * reviewer opens them, so these are not screens to leave until last. The words
 * live in `@/design` and are rendered by both frontends; what is here is the
 * chrome and this app's own `Link`.
 *
 * Deliberately **not guarded**: the whole point is that anybody can read them,
 * including somebody who has just deleted their account and has no session at
 * all.
 */
function Link({
  href,
  className,
  children,
}: {
  href: string;
  className?: string;
  children: ReactNode;
}) {
  return (
    <RouterLink to={href} className={className}>
      {children}
    </RouterLink>
  );
}

export function PrivacyScreen() {
  return (
    <PublicPage>
      <PrivacyContent Link={Link} />
    </PublicPage>
  );
}

export function SupportScreen() {
  return (
    <PublicPage>
      <SupportContent Link={Link} />
    </PublicPage>
  );
}
